import { getSettingHelpCenterChatAvailableLocales } from "@faire/help-center-utils/settings/getSettingHelpCenterChatAvailableLocales";
import { ILocaleKey } from "@faire/web-api--source/indigofair/locale/ILocaleKey";

export const isLocaleChatSupported = (locale: ILocaleKey): boolean => {
  return getSettingHelpCenterChatAvailableLocales().some(
    (supportedLocale) =>
      supportedLocale.country === locale.country &&
      supportedLocale.language === locale.language
  );
};
